import React   from "react";
import "./styles.css";

export function QuickPanel() {
  return (
    <></>
    // <div id="kt_quick_panel" className="offcanvas offcanvas-left pt-5 pb-10">
    // 	<Tab.Container defaultActiveKey={selectedTab}>
    // 		{/*begin::Header*/}
    // 		<div className="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5">
    // 			<div
    // 				className="offcanvas-close mt-n1 pr-5"
    // 				style={{ position: 'absolute', top: '15px', right: '10px', float: 'left' }}
    // 			>
    // 				<a
    // 					href="#"
    // 					className="btn btn-xs btn-icon btn-light btn-hover-primary"
    // 					id="kt_quick_panel_close"
    // 					style={{ float: 'left' }}
    // 				>
    // 					<i className="ki ki-close icon-xs text-muted"></i>
    // 				</a>
    // 			</div>
    // 			<h5 style={{ margin: 20 }} className="font-weight-bold mb-5">
    // 				انتخاب صندلی
    // 			</h5>
    // 		</div>
    // 		{/*end::Header*/}
    // 		<Divider />

    // 		{/*begin::Content*/}
    // 		{/* <div className="offcanvas-content" style={{ paddingLeft: 20 }}>
    // 			<div className="tab-content">
    // 				<div
    // 					id="kt_quick_panel_logs"
    // 					role="tabpanel"
    // 					className={` ${selectedTab === 'AuditLogs' ? 'active show' : ''}`}
    // 				>
    // 					<div className="mb-15"></div>
    // 					{data.car_location_schema.map(item => {
    // 						return (
    // 							<div
    // 								key={item.id}
    // 								onClick={() => handleReserved(item.seat_number)}
    // 								className="item"
    // 								style={{
    // 									position: 'absolute',
    // 									top: 70 * `${item.row_id}`,
    // 									right: 70 * `${item.column_id}`,
    // 								}}
    // 							>
    // 								{returnIcon(item.car_location_type_id, item.seat_number)}
    // 							</div>
    // 						);
    // 					})}
    // 				</div>
    // 			</div>
    // 		</div> */}

    // 		{/*end::Content*/}
    // 	</Tab.Container>
    // </div>
  );
}
